import { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import axios from 'config/axios';
import styles from './signup.module.css';
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, AlertTitle, CircularProgress, IconButton } from '@mui/material';
import { LANGUAGES } from 'utils/Constants';
import i18n from 'i18next';
function Signup() {
  const history = useHistory();
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    nom: '',
    prenom: '',
    password: '',
    passwordConfirm: '',
    telephone: '',
    societe: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [language, setLanguage] = useState(i18n.language);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setLanguage(languageCode);
    localStorage.setItem('language', languageCode);
  };

  const getImageByLanguage = () => {
    return language?.startsWith('en')
      ? '/Images/illu-login-en.png'
      : '/Images/illu-login.png';
  };
  const isStrongPassword = (pwd) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(pwd);
  };

  const validateStep = () => {
    const errors = {};

    if (step === 1) {
      if (!formData.email) {
        errors.email = t("L'adresse email est obligatoire.");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        errors.email = "L'adresse email n'est pas valide.";
      }
    }

    if (step === 2) {
      if (!formData.nom) {
        errors.nom = t('Le nom est obligatoire.');
      }
      if (!formData.prenom) {
        errors.prenom = t('Le prénom est obligatoire.');
      }
    }

    if (step === 3) {
      if (!formData.password) {
        errors.password = t('Le mot de passe est obligatoire.');
      } else if (!isStrongPassword(formData.password)) {
        errors.password =
          t('Mot de passe faible : au moins 8 caractères, une majuscule, une minuscule, un chiffre.');
      }

      if (!formData.passwordConfirm) {
        errors.passwordConfirm = t('La confirmation est obligatoire.');
      } else if (formData.password !== formData.passwordConfirm) {
        errors.passwordConfirm = t('Les mots de passe ne correspondent pas.');
      }
    }
    if (step === 4) {
      if (!formData.societe) {
        errors.societe = t('Le nom de votre société est obligatoire pour regrouper vos utilisateurs');
      }

    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setStep(step + 1);
      setFormErrors({});
      setError('');
    }
  };
  const handleBack = () => {
    setStep(step - 1);
    setError('');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async () => {
    if (!validateStep()) return;

    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/user/auth/admin-client/register', {
        mail: formData.email,
        password: formData.password,
        passwordConfirmation: formData.passwordConfirm,
        firstName: formData.prenom,
        lastName: formData.nom,
        phoneNumber: formData.telephone,
        companyName: formData.societe,
        isoLanguageCode: language,
      });
      if (response?.status === 202) {
        history.push('/SucessSignup', { companyAlreadyExists: true });
      } else {
        history.push('/SucessSignup');
      }
    } catch (err) {
      const message = err.response?.data?.message || '';
      const status = err.response?.status;
      if (
        status === 406 ||
        message.includes('existe') ||
        message.toLowerCase().includes('already')
      ) {
        setError(t('Un compte avec cette adresse email existe déjà.'));
      } else {
        setError(
          t('Oups, il semble qu\'un problème soit survenu lors de l\'inscription. Veuillez contacter notre support : support-typix@pixalione.com.')
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.SignupContainer}>
      <div className={styles.SignupFormContainer}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
          <img
            src="/Images/new1-logo.png"
            alt="Logo Typix"
            className={styles.logo}
          />


          <div className="btn-menu-icon" style={{ position: 'absolute', right: '0', top: '50%', transform: 'translateY(-50%)' }}>
            <div
              className="box-icon-menu dropdown-toggle d-flex flex-row align-items-center"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>
                <div className="flag-img-container-country">
                  <img
                    src={
                      LANGUAGES.find(({ isoCode }) => isoCode === language)
                        ?.img
                    }
                    alt="langage icon"
                  />
                </div>
              </span>
            </div>
            <ul
              className="dropdown-menu menu-list-nav menu-list-lng"
              aria-labelledby="dropdownMenu2"
            >
              {LANGUAGES.filter(({ isoCode }) => isoCode === 'fr' || isoCode === 'en').map(({ isoCode, img }, index) => (
                <li
                  key={index}
                  onClick={() => handleChangeLanguage(isoCode)}
                >
                  <button
                    className="dropdown-item d-flex justify-content-center"
                    type="button"
                  >
                    <div className="flag-img-container">
                      <img src={img} alt="language icon" />
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <h1 className={styles.formTitle}>{t('Bienvenue !')}</h1>
        <p className={styles.formSubTitle}>
          {t('Créez un compte gratuitement pour commencer à gérer vos contenus.')}
        </p>

        <div className={styles.signupProgressBar}>
          <div
            className={styles.signupProgress}
            style={{ width: `${(step / 4) * 100}%` }}
          ></div>
        </div>

        {error && <p style={{ color: 'red', marginBottom: 10 }}>{error}</p>}

        <form
          className={styles.SignupForm}
          onSubmit={(e) => e.preventDefault()}
        >
          {step === 1 && (
            <div className={styles.formStep}>
              <div className={styles.inputContainer}>
                <label htmlFor="email" style={{ textAlign: 'left' }}>Email*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('Veuillez saisir votre adresse mail')}
                />
                {formErrors.email && (
                  <p className={styles.errorText}>{formErrors.email}</p>
                )}
                <button
                  type="button"
                  onClick={handleNext}
                  className={styles.SignUpButton}
                >
                  {t('Suivant')}
                </button>
                <div className={styles.separator}>
                  <span>
                    {t('Vous avez déjà un compte ?')} {''}{' '}
                    <a href="/login">{t('Connectez vous')}</a>
                  </span>
                </div>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className={styles.formStep}>
              <div className={styles.inputContainer}>
                <label htmlFor="nom" style={{ textAlign: 'left' }}>{t('Nom*')}</label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                />
                {formErrors.nom && (
                  <p className={styles.errorText}>{formErrors.nom}</p>
                )}
                <label htmlFor="prenom" style={{ textAlign: 'left' }}>{t('Prénom*')}</label>
                <input
                  type="text"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleChange}
                  required
                />
                {formErrors.prenom && (
                  <p className={styles.errorText}>{formErrors.prenom}</p>
                )}
                <button
                  type="button"
                  onClick={handleNext}
                  className={styles.SignUpButton}
                >
                  {t('Suivant')}
                </button>
              </div>
              <div className={styles.backLinkContainer}>
                <button
                  type="button"
                  className={styles.backLink}
                  onClick={handleBack}
                >
                  {t('Retour')}
                </button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className={styles.formStep}>
              <div className={styles.inputContainer}>
                <label htmlFor="password" style={{ textAlign: 'left' }}>{t('Mot de passe*')}</label>
                <div className={styles.passwordWrapper}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder={t('Entrez votre mot de passe')}
                  ></input>

                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleTogglePasswordVisibility}
                    className={styles.togglePassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </div>
                {formErrors.password && (
                  <p className={styles.errorText}>{formErrors.password}</p>
                )}
                <label htmlFor="passwordConfirm" style={{ textAlign: 'left' }}>
                  {t('Confirmer le mot de passe*')}
                </label>
                <div className={styles.passwordWrapper}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="passwordConfirm"
                    name="passwordConfirm"
                    value={formData.passwordConfirm}
                    onChange={handleChange}
                    required
                    placeholder={t('Confirmez votre mot de passe')}
                  ></input>

                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleTogglePasswordVisibility}
                    className={styles.togglePassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </div>
                {formErrors.passwordConfirm && (
                  <p className={styles.errorText}>
                    {formErrors.passwordConfirm}
                  </p>
                )}
                <button
                  type="button"
                  onClick={handleNext}
                  className={styles.SignUpButton}
                >
                  {t('Suivant')}
                </button>
              </div>
              <div className={styles.backLinkContainer}>
                <button
                  type="button"
                  className={`${styles.backLink} ${styles.SignUpButton}`}
                  onClick={handleBack}
                >
                  {t('Back')}
                </button>
              </div>
            </div>
          )}

          {step === 4 && (
            <div className={styles.formStep}>
              <div className={styles.inputContainer}>
                <label htmlFor="telephone" style={{ textAlign: 'left' }}>{t('Numéro de téléphone')}</label>
                <input
                  type="tel"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="societe" style={{ textAlign: 'left' }}>{t('Société*')}</label>
                <input
                  type="text"
                  name="societe"
                  value={formData.societe}
                  onChange={handleChange}
                  required
                />
                {formErrors.societe && (
                  <p className={styles.errorText}>{formErrors.societe}</p>
                )}

                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading}
                  className={styles.SignUpButton}
                >
                  {loading ? t('Chargement...') : t("S'inscrire")}
                </button>
              </div>

              <div className={styles.legalText}>
                {t('En poursuivant, vous acceptez les Conditions d\'utilisation et la  Politique de confidentialité.')}

              </div>

              <div className={styles.backLinkContainer}>
                <button
                  type="button"
                  className={`${styles.backLink} ${styles.SignUpButton}`}
                  onClick={handleBack}
                >
                  {t('Retour')}
                </button>
              </div>
            </div>
          )}
        </form>
      </div>

      <div className={styles.gradientBox}>
        <h1 className={styles.loginTitle}>{t('Accélérez votre stratégie')}</h1>
        <br />
        <h1
          style={{
            marginLeft: '470px',
            fontWeight: '450',
            color: '#1A1A1A',
          }}
        >
          {t(' de contenu.')}
        </h1>
        <p className={styles.loginSubTitle}>
          {t('IA générative, optimisation SEO avancée et validation  ')}
        </p>
        <br />
        <p
          style={{
            marginLeft: '450px',
            color: '#00000066',
            fontSize: '15px',
          }}
        >
          {t('humaine intégrées dans un seul workflow.')}
        </p>
        <img
          src={getImageByLanguage()}
          alt="Signup"
          className={styles.loginImage}
        />
      </div>
    </div>
  );
}

export default Signup;
